import { AddressView } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import type { ParsedTxEvent } from "./types";

interface EventListProps {
  events: ParsedTxEvent[];
}

const bigintReplacer = (_key: string, value: unknown) =>
  typeof value === "bigint" ? value.toString() : value;

export const EventList: FC<EventListProps> = ({ events }) => {
  if (events.length === 0) {
    return (
      <div className="text-sm text-gray-400">
        No events in this transaction.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {events.map(event => {
        const body = event.decoded
          ? event.args
          : { topics: event.topics, data: event.data };
        return (
          <div
            key={event.logIndex}
            className="flex flex-col gap-2 rounded-md border border-gray-700 p-3"
          >
            <div className="flex flex-row flex-wrap items-baseline gap-2 text-sm">
              <span className="font-medium text-gray-200">
                {event.decoded ? (event.contractName ?? "") : ""}
              </span>
              <code className="text-xs text-gray-400">
                <AddressView address={event.address} compact={event.decoded} />
              </code>
              <span className="font-mono text-sm text-blue-300">
                {event.decoded ? event.eventName : ""}
              </span>
              <span className="ml-auto text-xs text-gray-500">
                #{event.logIndex}
              </span>
            </div>
            <pre className="overflow-x-auto rounded bg-gray-900 p-2 text-xs text-gray-200">
              {JSON.stringify(body, bigintReplacer, 2)}
            </pre>
          </div>
        );
      })}
    </div>
  );
};
